import { useState } from 'react';
import PropTypes from 'prop-types';
import { AspectRatio, Center, Button, Text, Stack } from '@mantine/core';
import { isNilOrEmpty } from '../utils';
import LoginBar from '../components/LoginBar';
import DesignPreviewCardMobile from '../components/DesignPreviewCard.mobile';
import MLDLandingPageImage from '../images/MyLandscapeDesignLanding.png';
import MLDIcon from '../images/MLDIcon.avif';
import NameDesignModalMobile from '../components/NameDesignModal.mobile';
import FreeTrialModalMobile from '../components/FreeTrialModal.mobile';
import { Constants, mobileBackground, white, border, borderRadius, colors } from '../constants';
import { login } from '../auth/auth';


const TAB_BAR_BUTTON_STYLE = {
  root: {
    height: '100%',
    minHeight: '60px',
    padding: '0px',
    fontSize: '12px',
    width: '100%',
    backgroundColor: white,
    border: `1px solid ${border}`,
    borderRadius: borderRadius.none,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0px'
  }
};

const TAB_BAR_TEXT_STYLE = { 
  whiteSpace: 'normal', 
  textAlign: 'center', 
  width: '100%', 
  display: 'inline-block',
  color: mobileBackground,
  fontSize: Constants.fontSize.xl,
  fontWeight: 'bold'
}

const UserDashboardMobile = ({
  user,
  designs,
  selectedDesignId,
  setSelectedDesignId,
  navigate,
  handleDuplicateSelected,
  handleEditSelected,
  handleDeleteSelected,
  handleSubmitGardenName,
  handleSkipGardenName
}) => {
  const [showLandingPage, setShowLandingPage] = useState(true);
  const [showAccountInfo, setShowAccountInfo] = useState(false);
  const [showSavedDesigns, setShowSavedDesigns] = useState(false);
  const [showNameGardenModal, setShowNameGardenModal] = useState(false);
  const [showFreeTrialModal, setShowFreeTrialModal] = useState(false);

  const backToWebsite = () => {
    window.open('https://mylandscapedesign.com', '_blank');
  };

  const navigateToSubscriptionPage = () => {
    window.open('https://www.mylandscapedesign.com/pricing-plans', '_blank');
  }

  const handleStartDesigningPress = () => {
    if (user.hasActiveSubscription) {
      setShowNameGardenModal(true);
    } else {
      navigateToSubscriptionPage();
      // navigate('/zone');
    }
  };

  const handleFreeTrialPress = () => {
    setShowFreeTrialModal(true);
  };

  const handleChoosePlan = () => {
    navigateToSubscriptionPage();
  };

  const handleContinueTrial = () => {
    navigate('/zone');
  };

  const freeTrialButton = () => {
    // Free trial disabled for now
    return null;
    /* return (
      <Button
        variant="filled"
        color="var(--median-window-color)"
        styles={() => ({
          root: {
            height: 'auto', 
            borderRadius: borderRadius.xl,
            backgroundColor: "white",
            width: '50vw',
            alignSelf: 'center'
          }
        })}
        onClick={handleFreeTrialPress}
      >
        <Text style={{
          fontSize: Constants.fontSize.xxxl,
          fontWeight: 'bold',
          color: mobileBackground,
          textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',
          paddingTop: 10,
          paddingBottom: 10,
          paddingLeft: 15,
          paddingRight: 15
        }}>{"Free Trial"}</Text>
      </Button>
    ) */
  }

  const loginButton = () => {
    return (
      <Button
        variant="filled"
        color="var(--median-window-color)"
        styles={() => ({
          root: {
            height: 'auto', 
            borderRadius: borderRadius.xl,
            backgroundColor: "white",
            width: '50vw',
            alignSelf: 'center'
          }
        })}
        onClick={login}
      >
        <Text style={{
          fontSize: Constants.fontSize.xxxl,
          fontWeight: 'bold',
          color: mobileBackground,
          textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',
          paddingTop: 10,
          paddingBottom: 10,
          paddingLeft: 15,
          paddingRight: 15
        }}>{"Login"}</Text>
      </Button>
    )
  }
  
  const subscribeButton = () => {
    return (
      <Button
        variant="filled"
        color="var(--median-window-color)"
        styles={() => ({
          root: {
            height: 'auto', 
            borderRadius: borderRadius.xl,
            backgroundColor: "white",
            width: '60vw',
            alignSelf: 'center'
          }
        })}
        onClick={navigateToSubscriptionPage}
      >
        <Text style={{
          fontSize: Constants.fontSize.xxxl,
          fontWeight: 'bold',
          color: mobileBackground,
          textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',
          paddingTop: 10,
          paddingBottom: 10,
          paddingLeft: 15,
          paddingRight: 15
        }}>{"Subscribe!"}</Text>
      </Button>
    )
  }

  /* ************* Main Content ************* */

  const renderHomeContent = () => {
    return (
      <AspectRatio ratio={3781/2656} mx="auto" width="100%">
        <div style={{ position: 'relative', marginTop: '50px'}}>
          <img
            src={MLDLandingPageImage}
            alt="Welcome to My Landscape Design!"
            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: borderRadius.small }}
          />
          
          <Center style={{
            marginTop: user.hasActiveSubscription ? '5vh' :'5vh', // Use 2vh for non subscribers when free trial active
            width: '100%',
          }}>
            {!user.loggedIn && (
              <Stack>
                {loginButton()}
                {freeTrialButton()}
              </Stack>
            )}
            {user.loggedIn && !user.hasActiveSubscription && (
              <Stack>
                {subscribeButton()}
                {freeTrialButton()}
              </Stack>
            )}
            {user.loggedIn && user.hasActiveSubscription && (
              <Button
                variant="filled"
                color="var(--median-window-color)"
                styles={() => ({
                  root: {
                    height: 'auto', 
                    borderRadius: borderRadius.xl,
                    backgroundColor: "white",
                  }
                })}
                onClick={handleStartDesigningPress}
              >
                <Text style={{
                  fontSize: Constants.fontSize.xxxl,
                  fontWeight: 'bold',
                  color: mobileBackground,
                  textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',
                  paddingTop: 25,
                  paddingBottom: 25,
                  paddingLeft: 15,
                  paddingRight: 15
                }}>{"Start Designing >"}</Text>
              </Button>
            )}
          </Center>
        </div>
      </AspectRatio>
    )
  };

  const renderAccountInfoContent = () => {
    return (
      <>
      <AspectRatio ratio={3781/2656} mx="auto" width="100%">
            <div style={{ position: 'relative', marginTop: '50px'}}>
              <img
                src={MLDLandingPageImage}
                alt="Welcome to My Landscape Design!"
                style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '5px' }}
              />
            </div>
          </AspectRatio>
        <Text style={{
          color: 'white',
          fontSize: '28px',
          fontWeight: 'bold',
          marginTop: '20px',
        }}>
          {`User: ${user.nickname}`}
        </Text>
        <Text style={{
          color: 'white',
          fontSize: '18px',
          fontWeight: 'bold',
          marginBottom: '10px'
        }}>
          {`Email: ${user.email}`}
        </Text>
        <Button
          onClick={() => window.open('https://www.mylandscapedesign.com/my-subscriptions', '_blank')}
          style={{
            color: 'white',
            fontSize: '18px',
            fontWeight: 'bold',
            marginBottom: '10px',
            marginTop: '30px',
            backgroundColor: 'lightgrey',
            borderRadius: '10px',
            //padding: '10px',
            paddingLeft: '25px',
            paddingRight: '25px',
            textAlign: 'center',
            lineHeight: '1.25',
            height: 'auto',
            minHeight: '60px'
          }}
        >
          Manage<br />Subscription
        </Button>
      </>
    )
  };

  const renderSavedDesignsContent = () => {
    return isNilOrEmpty(designs) ? 
      (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <Text>No designs found. Create your first design!</Text>
        </div>
      ) : 
      (
        <Stack w="100%" align="center" style={{ paddingTop: '20px' }}>
          {designs.map((design) => (
            <DesignPreviewCardMobile
              key={design.designId}
              design={design}
              isSelected={design.designId === selectedDesignId}
              onClick={() => setSelectedDesignId(design.designId)}
              onDuplicate={() => handleDuplicateSelected(design.designId)}
              onEdit={handleEditSelected}
              onDelete={handleDeleteSelected}
            />
          ))}
        </Stack>
      )
  };

  /* ************* Tab Bar Button Handlers ************* */

  const handleHomePress = () => {
    setShowLandingPage(true);
    setShowAccountInfo(false);
    setShowSavedDesigns(false);
  };

  const handleAccountInfoPress = () => {
    setShowAccountInfo(true);
    setShowLandingPage(false);
    setShowSavedDesigns(false);
  };

  const handleSavedDesignsPress = () => {
    setShowSavedDesigns(true);
    setShowLandingPage(false);
    setShowAccountInfo(false);
  };

  /* ************* Tab Bar Buttons ************* */

  const renderSavedDesignsButton = () => {
    if (!user.loggedIn) {
      return null;
    }

    return (
      <Button 
        onClick={handleSavedDesignsPress}
        variant="light"
        color="green"
        autoContrast
        fullWidth={false}
        styles={TAB_BAR_BUTTON_STYLE}
      >
        <Text style={TAB_BAR_TEXT_STYLE}>
          Saved Designs
        </Text>
      </Button>
    )
  };

  const renderBackToWebsiteButton = () => {
    return (
      <Button 
        onClick={backToWebsite}
        variant="light"
        color="green"
        autoContrast
        fullWidth={false}
        styles={TAB_BAR_BUTTON_STYLE}
      >
        <img 
          src={MLDIcon} 
          alt="MyLandscapeDesign" 
          style={{ 
            width: '80%', 
            height: '80%',
            objectFit: 'contain',
            margin: '0 auto'
          }} 
        />
      </Button>
    )
  };

  const renderHomeButton = () => {
    return (
      <Button 
        onClick={handleHomePress}
        variant="light"
        color="green"
        autoContrast
        fullWidth={true}
        styles={TAB_BAR_BUTTON_STYLE}
      >
        <Text style={TAB_BAR_TEXT_STYLE}>
          Home
        </Text>
      </Button>
    )
  };

  const renderAccountInfoButton = () => {
    if (!user.loggedIn) {
      return null;
    }

    return (
      <Button 
        onClick={handleAccountInfoPress}
        variant="light"
        color="green"
        autoContrast
        fullWidth={true}
        styles={TAB_BAR_BUTTON_STYLE}
      >
        <Text style={TAB_BAR_TEXT_STYLE}>
          Account Info
        </Text>
      </Button>
    )
  };

  const renderHomeTabBar = () => {
    return (
      <>
        {renderSavedDesignsButton()}
        {renderBackToWebsiteButton()}
        {renderAccountInfoButton()}
      </>
    )
  }

  const renderAccountInfoTabBar = () => {
    return (
      <>
        {renderHomeButton()}
        {renderBackToWebsiteButton()}
        {renderSavedDesignsButton()}        
      </>
    )
  }

  const renderSavedDesignsTabBar = () => {
    return (
      <>
        {renderHomeButton()}
        {renderBackToWebsiteButton()}
        {renderAccountInfoButton()}
      </>
    )
  }


  const getWelcomeMessage = () => {
    if (user?.nickname) {
      return `Welcome, ${user?.nickname}`;
    } else {
      return `Welcome to MyLandscapeDesign!`;
    }
  }

  return (
    <div style={{ 
      width: '100vw', 
      height: '100vh', 
      backgroundColor: '#324d2c',
      overflowX: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box'
    }}>
     
      {/* Mobile Header */}
      <header style={{ 
        textAlign: 'center', 
        padding: '10px',
        backgroundColor: colors.backgroundLight,
        height: '120px',
        borderBottom: `10px solid ${white}`,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        alignItems: 'center',
        position: 'relative'
      }}>
        <h1 style={{ 
          margin: '0', 
          fontSize: '24px',
          marginBottom: '0px'
        }}>
          {getWelcomeMessage()}
        </h1>
        <LoginBar />
      </header>

      {/* Mobile Content */}
      <div style={{ 
        backgroundColor: mobileBackground,
        paddingLeft: '20px',
        paddingRight: '20px',
        flex: 1,
        overflowY: 'auto',
        paddingBottom: '100px'
      }}>
        {showLandingPage && renderHomeContent()}
        {showAccountInfo && renderAccountInfoContent()}
        {showSavedDesigns && renderSavedDesignsContent()}
      </div>

      {/* Mobile Tab Bar */}
      <div style={{ 
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        padding: '2px',
        backgroundColor: mobileBackground,
        borderTop: `1px solid ${border}`,
        height: '135px',
        zIndex: 1000,
        gap: '2px'
      }}>
        {showLandingPage && renderHomeTabBar()}
        {showAccountInfo && renderAccountInfoTabBar()}
        {showSavedDesigns && renderSavedDesignsTabBar()}
      </div>
      
      {/* Name Design Modal */}
      <NameDesignModalMobile
        isOpen={showNameGardenModal}
        onClose={() => setShowNameGardenModal(false)}
        onSubmit={handleSubmitGardenName}
        onSkip={handleSkipGardenName}
      />

      {/* Free Trial Modal */}
      <FreeTrialModalMobile
        isOpen={showFreeTrialModal}
        onClose={() => setShowFreeTrialModal(false)}
        onChoosePlan={handleChoosePlan}
        onContinueTrial={handleContinueTrial}
      />
    </div>
  );
};

UserDashboardMobile.propTypes = {
  user: PropTypes.shape({
    nickname: PropTypes.string,
    email: PropTypes.string,
    hasActiveSubscription: PropTypes.bool,
    loggedIn: PropTypes.bool
  }),
  designs: PropTypes.array,
  selectedDesignId: PropTypes.string,
  setSelectedDesignId: PropTypes.func,
  handleCreate: PropTypes.func,
  navigate: PropTypes.func,
  handleDuplicateSelected: PropTypes.func,
  handleEditSelected: PropTypes.func,
  handleDeleteSelected: PropTypes.func,
  handleSubmitGardenName: PropTypes.func,
  handleSkipGardenName: PropTypes.func
};

export default UserDashboardMobile;
